import handler from 'api/handler';

const prefix = '/admin/payment';

const methods = {
    updatePaymentPlan: args => handler({ method: 'put', url: prefix + '/updatePaymentPlan', args }),
    removePaymentPlan: args => handler({ method: 'put', url: prefix + '/removePaymentPlan', args }),
    getPaymentStatus: ({ paymentId }) => handler({ method: 'get', url: `${prefix}/paymentStatus/${paymentId}` }),
    sendPaymentLink: args => handler({ method: 'post', url: prefix + '/sendPaymentLink', args})
    }

export default methods;